import { TEMPLATE_ID } from "./constants";

export const getOverallRanking = (fansUnitedSDK, groupId = undefined, filters = {}) => {
	const defaultFilters = { limit: 20, page: 1, ...filters };
	if (groupId) {
		defaultFilters.groupId = groupId;
	}
	return fansUnitedSDK.loyalty.getLeaderboard(TEMPLATE_ID, defaultFilters, true);
};

export const getMyRanking = (fansUnitedSDK) => {
	console.log("getMyRanking TEMPLATE_ID", TEMPLATE_ID);
	return fansUnitedSDK.loyalty.getOwnRankings({
		leaderboardIds: [TEMPLATE_ID],
		rankType: "template",
	});
};

export const getRoundRanking = (fansUnitedSDK, groupId, filters = {}) => {
	console.log("getRoundRanking called with:", { TEMPLATE_ID, groupId });
	const defaultFilters = {
		groupId: groupId,
		limit: 20,
		page: 1,
		...filters,
	};
	console.log("getRoundRanking filters:", defaultFilters);
	return fansUnitedSDK.loyalty.getLeaderboard(TEMPLATE_ID, defaultFilters, true);
};

export const getMyWeeklyRanking = async (fansUnitedSDK, groupId, userId) => {
	console.log("getMyWeeklyRanking called with:", { TEMPLATE_ID, groupId, userId });

	try {
		// Fetch weekly leaderboard with large limit to find user
		const filters = {
			groupId: groupId,
			limit: 1000,
			page: 1,
		};

		const response = await fansUnitedSDK.loyalty.getLeaderboard(TEMPLATE_ID, filters, true);
		console.log("Weekly leaderboard response:", response);

		if (!response.data || !Array.isArray(response.data)) {
			console.log("No leaderboard data found");
			return { data: [] };
		}

		// Find current user in the leaderboard data
		const userRanking = response.data.find((player) => player.profileId === userId || player.profileModel?.id === userId);

		if (userRanking) {
			console.log("Found user in weekly leaderboard:", userRanking);
			// Format response to match expected structure
			return {
				data: [
					{
						id: TEMPLATE_ID,
						position: userRanking.position,
						points: userRanking.points,
						profileId: userRanking.profileId,
						profileModel: userRanking.profileModel,
					},
				],
			};
		} else {
			console.log("User not found in weekly leaderboard");
			return { data: [] };
		}
	} catch (error) {
		console.error("Error fetching weekly user ranking:", error);
		throw error;
	}
};

/**
 * Get current points based on user predictions, filtered by matches and markets
 * @param {Array} userPredictions - Array of user predictions
 * @param {Array} matches - Array of current matches
 * @param {Array} availableMarkets - Array of available markets
 * @returns {number} Total current points for filtered predictions
 */
export const getMyCurrentPoints = (userPredictions, matches, availableMarkets) => {
	if (!userPredictions || !Array.isArray(userPredictions)) {
		return 0;
	}

	// Get match IDs and market types for filtering
	const matchIds = matches?.map((match) => match.id) || [];
	const marketTypes = availableMarkets?.map((market) => market.type) || [];

	// Filter predictions that match current matches and available markets
	const filteredPredictions = userPredictions.filter((prediction) => {
		const matchExists = matchIds.length === 0 || matchIds.includes(prediction.matchId);
		const marketExists = marketTypes.length === 0 || marketTypes.includes(prediction.market);
		return matchExists && marketExists;
	});

	// Sum up the points from filtered predictions
	return filteredPredictions.reduce((total, prediction) => {
		return total + (prediction.result?.points || 0);
	}, 0);
};
